import React, {Component} from 'react';
import { connect } from 'react-redux';
import {withStyles} from "@material-ui/core";
import {bindActionCreators} from "redux";
import {actionCreators as offerActions} from "../../store/Offer";
import Paper from "@material-ui/core/Paper";
import AppBar from "@material-ui/core/AppBar/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Grid from "@material-ui/core/Grid";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import Typography from "@material-ui/core/Typography";
import history from "../../helpers/historyHelper";
import Moment from "react-moment";
import Button from "@material-ui/core/Button";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import FormControl from "@material-ui/core/FormControl";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";

const styles = theme => ({
    paper: {
        overflow: 'hidden',
    },
    searchBar: {
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    },
    searchInput: {
        fontSize: theme.typography.fontSize,
    },
    block: {
        display: 'block',
    },
    newOffer: {
        marginRight: theme.spacing(1),
    },
    contentWrapper: {
        margin: '40px 26px',
    },
    itemRow: {
        cursor: "pointer",
        "&:hover": {
            background: "#efefef"
        }
    }
});



class AllCases extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isAssigningUser: false,
            assignCaseworkerForSaving: {
                offerId: null,
                userId: null,
            },
        };
    }
    
    openAssignCaseToUser = (offerId) => (event) => {
        event.stopPropagation();
        this.setState(prevState => ({
            isAssigningUser: true,
            assignCaseworkerForSaving: {
                ...prevState.assignCaseworkerForSaving,
                offerId: offerId
            }
        }));
    };

    assignCaseToUser = () => {
        console.log(this.state);
        this.props.offerActions.assignCaseWorker(this.state.assignCaseworkerForSaving, this.assignCaseToUserSuccess);
    };

    assignCaseToUserSuccess = () => {
        this.setState({
            isAssigningUser: false,
            assignCaseworkerForSaving: {
                userId: null,
                offerId: null
            }
        });
        this.props.offerActions.getOffers();
    };

    handleInputChangeAssignUserToCase = () => event => {
        console.log(event);
        const target = event.target;
        if(target !== null) {
            const value = target.value;
            this.setState(prevState => ({
                assignCaseworkerForSaving: {
                    ...prevState.assignCaseworkerForSaving,
                    userId: value    
                }
            }));
        }
    };
    
    render() {
        const {classes} = this.props;
        const {isAssigningUser} = this.state;
        return (
            <div>

                <Dialog
                    open={isAssigningUser}
                    onClose={() => {this.setState({isAssigningUser: false})}}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    maxWidth={"xs"}
                fullWidth={true}>
                    <DialogTitle id="alert-dialog-title">{"Tildel sak"}</DialogTitle>
                    <DialogContent>
                        <FormControl variant="outlined" className={classes.formControl} fullWidth={true}>
                            <InputLabel id="select-caseofficer-label">
                                Saksbehandler
                            </InputLabel>
                            <Select
                                id="select-caseofficer-outlined"
                                name='caseofficer'
                                labelWidth={120}
                                value={this.state.assignCaseworkerForSaving.userId || ''}
                                onChange={this.handleInputChangeAssignUserToCase()}>
                                <MenuItem value={''}>
                                    <em>Velg</em>
                                </MenuItem>
                                {this.props.offer.caseWorkers.map((row, index) => (
                                    <MenuItem key={index} value={row.userId}>{row.fullname}</MenuItem>
                                ))}
                                
                            </Select>
                        </FormControl>
                    </DialogContent>
                    <DialogActions>
                        <Button color="primary" onClick={() => {this.setState({isAssigningUser:false})}}>
                            Avbryt
                        </Button>
                        <Button color="primary" autoFocus onClick={this.assignCaseToUser}>
                            Tildel
                        </Button>
                    </DialogActions>
                </Dialog>
                
                <h1>Oversikt over registrerte tilbud</h1>
                <Paper className={classes.paper}>
                    <AppBar className={classes.searchBar} position="static" color="default" elevation={0}>
                        <Toolbar>
                            <Grid container spacing={2} alignItems="center">
                                <Grid item xs>
                                    <h3>Alle tilbud</h3>
                                </Grid>
                            </Grid>
                        </Toolbar>
                    </AppBar>
                    <div className={classes.contentWrapper}>
                        {this.props.offer.offers.length !== 0 &&
                        <Table className={classes.table} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell algin="left">Ref.Nr</TableCell>
                                    <TableCell align="left">Produkt</TableCell>
                                    <TableCell align="left">Status</TableCell>
                                    <TableCell align="left">Organisasjon</TableCell>
                                    <TableCell align="left">Saksbehandler</TableCell>
                                    <TableCell align="left">Registrert av</TableCell>
                                    <TableCell align="left">Registrert dato</TableCell>
                                    <TableCell align="left">&nbsp;</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.props.offer.offers.filter(function(x) {return x.offerStatusId !== 5;}).map(row => (
                                    <TableRow className={ classes.itemRow } key={row.offerId} onClick={() => {history.push(`/offer/${row.offerId}`)}}>
                                        <TableCell align="left">{row.offerId}</TableCell>
                                        <TableCell align="left">{row.title}</TableCell>
                                        <TableCell align="left">{row.offerStatus.status}</TableCell>
                                        <TableCell align="left">{row.organization.name}</TableCell>
                                        <TableCell align="left">{row.offerCaseWorkerUser && row.offerCaseWorkerUser.fullname}</TableCell>
                                        <TableCell align="left">{row.registeredByUser.fullname}</TableCell>
                                        <TableCell align="left"><Moment>{row.registeredDate}</Moment></TableCell>
                                        <TableCell align="right">{(row.offerStatusId === 2 ||row.offerStatusId === 3 ||row.offerStatusId === 4||row.offerStatusId===8) && (<Button variant="contained" color="primary" size={"small"} onClick={this.openAssignCaseToUser(row.offerId)}>Tildel saksbehandler</Button>)}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                        }

                        {this.props.offer.offers.length === 0 &&
                        <Typography color="textSecondary" align="center">
                            Ingen saker tilgjengelig
                        </Typography>
                        }
                    </div>
                </Paper>
            </div>
        )
    };

    componentDidMount() {
        this.props.offerActions.getOffers();
        this.props.offerActions.getCaseWorkers();
    }
    componentWillUnmount() {
        
    }
}

function mapDispatchToProps(dispatch) {
    return {
        offerActions: bindActionCreators(offerActions, dispatch),
    }
}

function mapStateToProps(state) {
    return {
        offer: state.offer,
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AllCases));
